import type {Components, Theme} from '@mui/material';
import mediaQuery from 'css-mediaquery';

declare global {
  /* eslint-disable no-var */
  var _device: string;
  /* eslint-enable no-var */
}

export const createUseMediaQuery = (theme: Theme): Components['MuiUseMediaQuery'] => {
  const device = globalThis._device;

  return {
    defaultProps: {
      ssrMatchMedia: (query) => {
        const isServer = typeof window === 'undefined';
        return {
          matches:
            isServer && !device
              ? false
              : mediaQuery.match(query, {
                  width: !isServer
                    ? window.innerWidth
                    : device === 'mobile'
                      ? theme.breakpoints.values.sm
                      : theme.breakpoints.values.lg,
                }),
        };
      },
    },
  };
};
